import app from "@/app";
import { TooltipController } from "./tooltip";

app.register("tooltip", TooltipController);
